import $ from 'jquery';

import 'bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-autocomplete';
import 'select2';

globalThis.$ = $;
globalThis.jQuery = $;
window.$ = $;
window.jQuery = $;

export * from 'tabulator-tables';
export * from 'js-cookie';
export * from 'moment-timezone';
export * from 'xlsx';
export * from 'jspdf';
export * from 'jspdf-autotable';
export * from 'exceljs';

export { $ as jquery, $ as jQuery };
export default $;
